// extracted by mini-css-extract-plugin
export default {"main":"_layout_main__kR+c3","bg":"_layout_bg__ppb2V","bgColor":"_layout_bgColor__pJQeb","content":"_layout_content__N+qe0","hairCheckContent":"_layout_hairCheckContent__g0wNV"};